// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".home[data-v-0e9632a2] {\n  width: 1.2rem;\n  height: 1.2rem;\n  z-index: 1000;\n  position: absolute;\n}\n.str[data-v-0e9632a2] {\n  width: 2.13333rem;\n  font-size: 0.37333rem;\n  color: #9e511c;\n}\n.str .arrow[data-v-0e9632a2] {\n  width: 0.42667rem;\n}\n.go-back-icon[data-v-0e9632a2] {\n  width: 0.74667rem;\n  height: 0.74667rem;\n  z-index: 1000;\n  position: absolute;\n  left: 0.53333rem;\n  top: 0.53333rem;\n}\n", ""]);
// Exports
module.exports = exports;
